import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
var BDataSourceService = (function () {
    function BDataSourceService(http) {
        this.http = http;
    }
    BDataSourceService.prototype.getDataSource = function () {
        return this.http.get('constants/app.const.json').map(function (res) {
            if (res && res.hasOwnProperty('_body')) {
                return res['_body'];
            }
        });
    };
    return BDataSourceService;
}());
export { BDataSourceService };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/service/bDataSource.service.ts.pre-build-optimizer.js